import * as React from "react";
import { render } from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import configureStore from "./redux/ConfigureStore";

import "./index.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import {App} from "./App";

const initialState = {};

const store = configureStore(initialState);

render(
	<ReduxProvider store={store}>
		<BrowserRouter>
			<Routes>
				<Route path = "/*" element={<App />}/>
			</Routes>
		</BrowserRouter>
	</ReduxProvider>,
	document.getElementById("root")
);
